exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".version-form{display:flex;gap:20px;margin-top:22px}.content-regions{max-width:400px;width:100%;text-wrap:nowrap;text-overflow:ellipsis;overflow:hidden}.m-0{margin:0}.mr-68{margin-right:68px!important}.md-select-value.md-select-placeholder{height:34px}md-input-container>md-select{width:165px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/pop-up/pop-up.scss
// module id = 824
// module chunks = 0